/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, convertHexToRGB } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT : IMAGE API : IMAGE TYPES : STYLES --------------- ++++++++++ */
export default theme => ({
	imagetypes: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginBottom: pxToEm(12),
        // actual nav item
        '& .imagetype': {
            backgroundColor: 'transparent',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: '50%',
            borderRadius: pxToEm(16),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            color: `rgba(6, 43, 117, 0.5)`,
            fontSize: pxToEm(16),
            textAlign: 'center',
            height: pxToEm(32),
            padding: replacePXinStringWithEM(`0 12px`),
            transition: theme.animation.general('all'),
            '&:hover': {
                '&:not(.selectedTab)': {
                    backgroundColor: theme.color.secondary.xlight.swatch
                },
            },
            '&.selectedTab': {
                backgroundColor: convertHexToRGB(theme.color.primary.medium.swatch, 10),
                color: theme.color.primary.medium.swatch,
                '&.unsplash': {
                    backgroundImage: `url(${url.image}/logo-unsplash-blue.png)`,
                },
                '&.shutterstock': {
                    backgroundImage: `url(${url.image}/logo-shutterstock-blue.png)`,
                }
            },
            '&.unsplash, &.shutterstock': {
                width: pxToEm(130),
                '& span': { display: 'none' }
            },
            '&.unsplash': {
                backgroundSize: '53%',
                backgroundImage: `url(${url.image}/logo-unsplash-grey.png)`
            },
            '&.shutterstock': {
                backgroundSize: '58%',
                backgroundImage: `url(${url.image}/logo-shutterstock-grey.png)`
            }
        }
	}
});
